import React from 'react';
import { Link } from 'react-router-dom';
import { FaBox, FaTruck, FaChartBar, FaClock, FaIndustry, FaBuilding, FaBullseye, FaExclamationTriangle, FaInfoCircle, FaCheckCircle } from 'react-icons/fa';
import './Logistics.css';

function Logistics() {
  return (
    <div className="logistics-page">
      <div className="page-header">
        <div className="breadcrumb">
          <Link to="/sagemcom" className="breadcrumb-item clickable">Sagemcom</Link>
          <span className="breadcrumb-separator">›</span>
          <span className="breadcrumb-item active">Logistics</span>
        </div>
        <h1>Logistics Management</h1>
        <p>Supply chain and inventory optimization for Sagemcom operations</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <FaBox className="stat-icon" />
          <div className="stat-content">
            <h3>Inventory Items</h3>
            <p className="stat-number">12,450</p>
            <span className="stat-change positive">+8%</span>
          </div>
        </div>
        
        <div className="stat-card">
          <FaTruck className="stat-icon" />
          <div className="stat-content">
            <h3>Active Shipments</h3>
            <p className="stat-number">342</p>
            <span className="stat-change positive">+15%</span>
          </div>
        </div>
        
        <div className="stat-card">
          <FaChartBar className="stat-icon" />
          <div className="stat-content">
            <h3>Fill Rate</h3>
            <p className="stat-number">96.8%</p>
            <span className="stat-change positive">+2.3%</span>
          </div>
        </div>
        
        <div className="stat-card">
          <FaClock className="stat-icon" />
          <div className="stat-content">
            <h3>Avg. Delivery</h3>
            <p className="stat-number">3.2 days</p>
            <span className="stat-change negative">-0.5d</span>
          </div>
        </div>
      </div>

      <div className="content-grid">
        <div className="content-section">
          <h3>Supply Chain Overview</h3>
          <div className="supply-chain-flow">
            <div className="flow-item">
              <FaIndustry className="flow-icon" />
              <div className="flow-content">
                <h4>Suppliers</h4>
                <p className="flow-count">45 Active</p>
                <span className="flow-status on-time">On Schedule</span>
              </div>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-item">
              <FaBuilding className="flow-icon" />
              <div className="flow-content">
                <h4>Warehouses</h4>
                <p className="flow-count">8 Locations</p>
                <span className="flow-status operational">Operational</span>
              </div>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-item">
              <FaBullseye className="flow-icon" />
              <div className="flow-content">
                <h4>Distribution</h4>
                <p className="flow-count">120 Points</p>
                <span className="flow-status active">Active</span>
              </div>
            </div>
          </div>
        </div>

        <div className="content-section">
          <h3>Warehouse Capacity</h3>
          <div className="warehouse-list">
            <div className="warehouse-item">
              <div className="warehouse-info">
                <h4>North Distribution Center</h4>
                <p>Location: Toronto, ON</p>
              </div>
              <div className="capacity-bar">
                <div className="capacity-fill" style={{width: '85%'}}></div>
              </div>
              <span className="capacity-text">85% Full</span>
            </div>
            <div className="warehouse-item">
              <div className="warehouse-info">
                <h4>East Storage Facility</h4>
                <p>Location: Montreal, QC</p>
              </div>
              <div className="capacity-bar">
                <div className="capacity-fill" style={{width: '67%'}}></div>
              </div>
              <span className="capacity-text">67% Full</span>
            </div>
            <div className="warehouse-item">
              <div className="warehouse-info">
                <h4>West Hub</h4>
                <p>Location: Vancouver, BC</p>
              </div>
              <div className="capacity-bar">
                <div className="capacity-fill warning" style={{width: '92%'}}></div>
              </div>
              <span className="capacity-text warning">92% Full</span>
            </div>
          </div>
        </div>
      </div>

      <div className="content-grid">
        <div className="content-section">
          <h3>Recent Shipments</h3>
          <div className="shipments-list">
            <div className="shipment-item">
              <div className="shipment-header">
                <span className="shipment-id">#SHP-8762</span>
                <span className="shipment-status in-transit">In Transit</span>
              </div>
              <div className="shipment-details">
                <p><strong>Origin:</strong> Toronto DC</p>
                <p><strong>Destination:</strong> Halifax Distribution Point</p>
                <p><strong>ETA:</strong> Nov 10, 2025</p>
              </div>
              <div className="shipment-progress">
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '65%'}}></div>
                </div>
                <span className="progress-text">65% Complete</span>
              </div>
            </div>

            <div className="shipment-item">
              <div className="shipment-header">
                <span className="shipment-id">#SHP-8761</span>
                <span className="shipment-status delivered">Delivered</span>
              </div>
              <div className="shipment-details">
                <p><strong>Origin:</strong> Vancouver Hub</p>
                <p><strong>Destination:</strong> Calgary Distribution</p>
                <p><strong>Delivered:</strong> Nov 8, 2025</p>
              </div>
              <div className="shipment-progress">
                <div className="progress-bar">
                  <div className="progress-fill complete" style={{width: '100%'}}></div>
                </div>
                <span className="progress-text">Completed</span>
              </div>
            </div>

            <div className="shipment-item">
              <div className="shipment-header">
                <span className="shipment-id">#SHP-8760</span>
                <span className="shipment-status pending">Pending</span>
              </div>
              <div className="shipment-details">
                <p><strong>Origin:</strong> Montreal Facility</p>
                <p><strong>Destination:</strong> Ottawa Hub</p>
                <p><strong>Scheduled:</strong> Nov 11, 2025</p>
              </div>
              <div className="shipment-progress">
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '10%'}}></div>
                </div>
                <span className="progress-text">Preparing</span>
              </div>
            </div>
          </div>
        </div>

        <div className="content-section">
          <h3>Inventory Alerts</h3>
          <div className="alerts-list">
            <div className="alert-item warning">
              <FaExclamationTriangle className="alert-icon" />
              <div className="alert-content">
                <h4>Low Stock Alert</h4>
                <p>Modem units (Model SGM-500) below reorder point</p>
                <span className="alert-time">2 hours ago</span>
              </div>
            </div>
            <div className="alert-item info">
              <FaInfoCircle className="alert-icon" />
              <div className="alert-content">
                <h4>Shipment Delayed</h4>
                <p>Shipment #SHP-8755 delayed by 1 day due to weather</p>
                <span className="alert-time">5 hours ago</span>
              </div>
            </div>
            <div className="alert-item success">
              <FaCheckCircle className="alert-icon" />
              <div className="alert-content">
                <h4>Restocked</h4>
                <p>Router inventory replenished at Toronto DC</p>
                <span className="alert-time">1 day ago</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content-section full-width">
        <h3>Top Products by Volume</h3>
        <div className="products-grid">
          <div className="product-card">
            <div className="product-icon">📡</div>
            <h4>SGM-500 Modem</h4>
            <p className="product-count">2,450 units</p>
            <div className="product-trend positive">
              <span>↗</span>
              <span>+12% this month</span>
            </div>
          </div>
          <div className="product-card">
            <div className="product-icon">🔌</div>
            <h4>Power Adapters</h4>
            <p className="product-count">5,280 units</p>
            <div className="product-trend positive">
              <span>↗</span>
              <span>+8% this month</span>
            </div>
          </div>
          <div className="product-card">
            <div className="product-icon">📶</div>
            <h4>WiFi Routers</h4>
            <p className="product-count">1,890 units</p>
            <div className="product-trend neutral">
              <span>→</span>
              <span>Stable</span>
            </div>
          </div>
          <div className="product-card">
            <div className="product-icon">🔧</div>
            <h4>Installation Kits</h4>
            <p className="product-count">3,120 units</p>
            <div className="product-trend positive">
              <span>↗</span>
              <span>+15% this month</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Logistics;

